import { ResourceTimingEntry, SearchRequestInstrumentation } from 'owa-search-service';
import { PerformanceDatapoint } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';

// Datapoint key for when the promise resolve marker is logged
const JS_PROMISE_KEY = 'promise';

export default mutatorAction(
    'addResourceTimingEntryMutator',
    function addResourceTimingEntryMutator(
        searchInstrumentationEntry: SearchRequestInstrumentation,
        resourceTimingEntry: ResourceTimingEntry,
        executeSearchDatapoint: PerformanceDatapoint
    ) {
        searchInstrumentationEntry.ResourceTimingEntry = resourceTimingEntry;

        // The end to end datapoint only exists for page 0 requests
        if (executeSearchDatapoint) {
            // Also log the JavaScript promise time from the executeSearchDatapoint now that it's available
            const jsEndToEndTimeWithRendering =
                executeSearchDatapoint.waterfallTimings[JS_PROMISE_KEY];

            // To be consistent with other clients, EndToEndTime is now defined to be without rendering time included
            searchInstrumentationEntry.ClientJSEndToEndTime =
                jsEndToEndTimeWithRendering - searchInstrumentationEntry.ClientJSRenderingTime;
        }
    }
);
